import { SubscriptionCreativeIcon, SubscriptionLicenseIcon, SubscriptionSupportIcon } from '@/components/icons/new'
import { SUBSCRIPTION_CREATIVE, SUBSCRIPTION_LICENSE, SUBSCRIPTION_SUPPORT } from './constants'

export const BILLING_CYCLES = {
    monthly: { label: 'Monthly', duration: 'Per Month' },
    quarterly: { label: 'Quarterly', duration: 'Per Month' },
    yearly: { label: 'Yearly', duration: 'Per Month' },
}

export const CREATIVE_TIERS = {
    start: { label: 'Start' },
    advance: { label: 'Advance' },
    pro: { label: 'Pro' },
}

export const SUBSCRIPTION_PLANS = [
    {
        id: SUBSCRIPTION_LICENSE,
        title: 'License',
        Icon: SubscriptionLicenseIcon,
        iconColor: '#7098FF',
        iconBg: '#132A62',
        kind: 'cycle',
        features: [
            '12 month growth AI learning plan',
            'Unlimited users',
            'Media monitoring',
            'Generative AI reports',
            'Media buying',
            '1 unique geo location',
            '5 Keywords',
        ],
    },
    {
        id: SUBSCRIPTION_SUPPORT,
        title: 'Support',
        Icon: SubscriptionSupportIcon,
        iconColor: '#32C05A',
        iconBg: '#0E3029',
        kind: 'cycle',
        features: [
            'Platform authentication',
            'Media buying integration',
            'Generative AI reports',
            'Notifications',
            'API integrations',
            'Leads generated reports',
            'Sales reports',
        ],
    },
    {
        id: SUBSCRIPTION_CREATIVE,
        title: 'Creative',
        Icon: SubscriptionCreativeIcon,
        iconColor: '#9F7AEA',
        iconBg: '#301D57',
        kind: 'tier',
        features: [
            'Onboarding',
            'Campaign setting',
            'Ad creative',
            'Prompt engineering',
            'Campaign purpose',
            'Campaign brief',
            'Optimisation',
        ],
    },
]
